module.exports = __webpack_public_path__ + "img/figure-3.992ce69a.png";